// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2wwNd","signatureBlock":"Footer_signatureBlock__17Hph","signature":"Footer_signature__1k6iC"};